<template>
  <div>
    <loading :active.sync="isLoading" color="#85344c"></loading>
    <div class="content-wrapper">
      <div class="container-fluid">
        <!-- Breadcrumbs-->
        <ol class="breadcrumb">
          <li class="breadcrumb-item active">Início</li>
        </ol>
        <!-- Icon Cards-->
        <div class="row">
          <div
            v-if="mostraErro"
            class="alert alert-danger alert-dismissible col-12"
            role="alert"
          >
            <button
              type="button"
              class="close"
              data-dismiss="alert"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
            <strong>Ops!</strong>
            <span>{{ mensagemErro }}</span>
          </div>
          <div class="col-xl-3 col-sm-6 mb-3">
            <div class="card dashboard text-white bg-primary o-hidden h-100">
              <div class="card-body">
                <div class="card-body-icon">
                  <i class="fa fa-fw fa-envelope-open"></i>
                </div>
                <div class="mr-5">
                  <h5>{{ dashboard.assinantes }} Usuários</h5>
                </div>
              </div>
              <!-- <router-link
                class="card-footer text-white clearfix small z-1"
                to="/uniodonto/planos"
              >
                <span class="float-left">Detalhes</span>
                <span class="float-right">
                  <i class="fa fa-angle-right"></i>
                </span>
              </router-link> -->
            </div>
          </div>
          <div class="col-xl-3 col-sm-6 mb-3">
            <div class="card dashboard text-white bg-warning o-hidden h-100">
              <div class="card-body">
                <div class="card-body-icon">
                  <i class="fa fa-fw fa-star"></i>
                </div>
                <div class="mr-5">
                  <h5>{{ dashboard.vendas }} Vendas no mês!</h5>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="box_general padding_bottom">
          <div class="header_box version_2">
            <h2><i class="fa fa-info"></i>Dados do contratante</h2>
          </div>
          <div class="row">
            <div class="col-md-4">
              <div class="form-group">
                <label>Nome</label>
                <input
                  v-model="user.name"
                  class="form-control"
                  placeholder="Nome"
                />
              </div>
            </div>
            <div class="col-md-4">
              <div class="form-group">
                <label>Sobrenome</label>
                <input
                  v-model="user.last_name"
                  class="form-control"
                  placeholder="Sobrenome"
                />
              </div>
            </div>
            <div class="col-md-4">
              <div class="form-group">
                <label>E-mail / Login</label>
                <input
                  v-model="user.email"
                  class="form-control"
                  placeholder="E-mail"
                  v-on:blur="preencheLogin"
                />
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-4">
              <div class="form-group">
                <label>Telefone</label>
                <input
                  class="form-control"
                  v-mask="'(##) 9####-####'"
                  type="tel"
                  v-model="phones"
                  @blur="
                    (e) => {
                      if (e.target.value.split(' ')[1]) {
                        user.phones.number = e.target.value
                          .split(' ')[1]
                          .replace('-', '');
                        user.phones.area_code = e.target.value
                          .split(' ')[0]
                          .replace(/[^0-9]/g, '');
                      } else if (e.target.value === '') {
                        user.phones.number = '';
                        user.phones.area_code = '';
                      }
                    }
                  "
                  placeholder="Telefone"
                  autocomplete="off"
                />
              </div>
            </div>
            <div class="col-md-4">
              <div class="form-group">
                <label>CPF</label>
                <input
                  class="form-control"
                  inputmode="numeric"
                  v-mask="'###.###.###-##'"
                  v-model="cpf"
                  @blur="
                    (e) => (user.cpf = e.target.value.replace(/[^0-9]/g, ''))
                  "
                  placeholder="CPF"
                  autocomplete="off"
                />
              </div>
            </div>
            <div class="col-md-4">
              <div class="form-group">
                <label>Senha</label>
                <div class="inputContainer">
                  <input
                    class="form-control"
                    :type="inputPasswordType"
                    name="password"
                    v-model="user.password"
                    placeholder="Senha"
                    autocomplete="new-password"
                  />
                  <i v-if="isLocked" class="fa fa-lock inputIcon" @click="changeIconPassword"></i>
                  <i v-else class="fa fa-unlock inputIcon" @click="changeIconPassword"></i>
                </div>
              </div>
            </div>
            <div class="col-md-4">
              <div class="form-group">
                <label>Criar usuário com acesso/e-mail válido?</label>
                <div class="flex checkboxContainer">
                  <label for="isVerified" class="mr-3 flex align-items-center">
                    <input id="isVerified" type="radio" v-model="user.verified_at" value="1" class="mr-2" />
                    Sim
                  </label>
                  <label for="notVerified" class="ml-3 flex align-items-center">
                    <input id="notVerified" type="radio" v-model="user.verified_at" value="0" class="mr-2" />
                    Não
                  </label>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="box_general padding_bottom">
          <div class="header_box version_2">
            <h2><i class="fa fa-map-marker"></i>Endereço do contratante</h2>
          </div>
          <div class="row">
            <div class="col-md-4">
              <div class="form-group">
                <label>CEP</label>
                <input
                  v-model="zip_code"
                  v-mask="'#####-###'"
                  @blur="(e) => getAddress(e.target.value)"
                  class="form-control"
                  type="tel"
                  placeholder="CEP"
                />
              </div>
            </div>
            <div class="col-md-4">
              <div class="form-group">
                <label>Cidade</label>
                <input
                  v-model="user.city"
                  class="form-control"
                  readonly
                  placeholder="Cidade"
                />
              </div>
            </div>
            <div class="col-md-4">
              <div class="form-group">
                <label>Estado</label>
                <input
                  v-model="user.state"
                  class="form-control"
                  readonly
                  placeholder="Estado"
                />
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-3">
              <div class="form-group">
                <label>Bairro</label>
                <input
                  v-model="user.district"
                  class="form-control"
                  placeholder="Bairro"
                />
              </div>
            </div>
            <div class="col-md-4">
              <div class="form-group">
                <label>Rua</label>
                <input
                  v-model="user.street"
                  class="form-control"
                  placeholder="Rua"
                />
              </div>
            </div>
            <div class="col-md-2">
              <div class="form-group">
                <label>Número</label>
                <input
                  class="form-control"
                  type="number"
                  v-model="user.street_number"
                  placeholder="N.º"
                />
              </div>
            </div>
            <div class="col-md-3">
              <div class="form-group">
                <label>Complemento</label>
                <input
                  v-model="user.complement"
                  class="form-control"
                  placeholder="Complemento"
                />
              </div>
            </div>
            <!-- <div class="col-md-2">
              <div class="form-group">
                <label>Naturalidade</label>
                <input
                  v-model="user.naturalidade"
                  class="form-control"
                  placeholder="naturalidade"
                />
              </div>
            </div> -->
            
          </div>
          <!-- <div class="row mb-3">
            <div class="col-md-5"> -->
              <!-- <div class="form-group">
                <label>Planos</label>
                <input @change="e => addPlan(e)" class="form-control" list="plans" />
                <datalist id="plans">
                  <template v-for="plano in planos">
                    <option v-if="user.plans.find(item => item.id == plano.id) ? false : true" :key="plano.id" :id="plano.id" :value="`${plano.id} - ${plano.name}`" />
                  </template>
                </datalist>
                <select id="plans" @change="e => addPlan(e)" class="form-control">
                  <template v-for="plano in planos">
                    <option value="" selected disabled hidden v-bind:key="plano.name">Escolha um plano</option>
                    <option v-if="user.plans.find(item => item.id == plano.id) ? false : true" :key="plano.id" :id="plano.id" :value="`${plano.id} - ${plano.name}`">
                      {{`${plano.id} - ${plano.name}`}}
                    </option>
                  </template>
                </select>
              </div> -->

              <!-- <template v-if="user.plans.length > 0">
               <label>Planos Selecionados:</label>
                <div class="list_plans">
                <template v-for="plano in user.plans">
                  <div class="item" v-if="planos.length > 0" :key="plano.id">
                
                    <img :src="planos.find((item) => item.id == plano.id).foto_plano"/>
                    <div class="container-nameCount">
                      <span class="name">
                        <b>{{
                          planos.find((item) => item.id == plano.id).name
                        }}</b>
                      </span>
                      <div class="counter">
                        <div class="op" @click="subPlan(plano)"><i>-</i></div>
                        <span class="quant">{{ plano.qtd }}</span>
                        <div class="op" @click="sumPlan(plano)"><i>+</i></div>
                      </div>
                    </div>

                  </div>
                </template>
              </div>
              </template> -->
            <!-- </div>
          </div> -->
        </div>

        <div class="row">
          <div class="col-md-12">
            <p>
              <button href="#0" @click="send" class="btn_1 medium pull-right mb-5">
                Continuar
              </button>
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import funcoesGerais from "@/assets/js/funcoes.js";
import { toTimeStamp } from "@/utils/formater";
import axios from "axios";
import VueApexCharts from "vue-apexcharts";
import { isEmail, isName } from "@/utils/validate";
import { cpf } from 'cpf-cnpj-validator';

export default {
  components: {
    apexcharts: VueApexCharts,
  },
  mixins: [funcoesGerais],
  data: function () {
    return {
      isLoading: false,
      isLocked: true,
      inputPasswordType: "password",
      phones: "",
      cpf: "",
      zip_code: "",
      user: {
        phones: {
          number: "",
          area_code: "",
        },
        name: "",
        last_name: "",
        email: "",
        login: "",
        password: "",
        street: "",
        street_number: "",
        naturalidade: "",
        complement: "",
        district: "",
        zip_code: "",
        city: "",
        cpf: "",
        state: "",
        country: "",
        plans: [],
        verified_at: "1"
      },
      planos: [],
      dashboard: {
        assinantes: 0,
        vendas: 0
      },
    };
  },
  mounted() {
    this.isLoading = true;
    const token = localStorage.getItem("token_adm_comprodonto")
      ? JSON.parse(localStorage.getItem("token_adm_comprodonto")).token
      : null;
    axios.all([
        axios.get(`plans_corretor/${this.parseJwt(token).usr.id}`),
        axios.get(`dashboard_corretor/${this.parseJwt(token).usr.id}`)
    ]).then(axios.spread((planosRes,dashboardRes) => {
        this.planos = planosRes.data;
        this.user.plans.push({id: this.planos[0].id, qtd: 1});
        this.dashboard = dashboardRes.data;
        this.isLoading = false;
    })).catch((err) => {
        this.isLoading = false;
        tratamento_requisicao(err, this);
    });
  },
  methods: {
    parseJwt(token) {
      var base64Url = token.split(".")[1];
      var base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
      var jsonPayload = decodeURIComponent(
        atob(base64)
          .split("")
          .map(function (c) {
            return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
          })
          .join("")
      );

      return JSON.parse(jsonPayload);
    },

    send(){
      this.isLoading = true;
      var checkFields = this.isEmpty(this.user);
      if (checkFields.length > 0) {
        this.isLoading = false;
        this.$swal.fire({
            position: "center",
            type: "error",
            title: "Os campos abaixo ainda precisam ser preenchidos!",
            html: checkFields,
            showConfirmButton: true,
          });
      } else {
        const emailValidate = isEmail(this.user.email);
        const nameValidate = isName(this.user.name);
        const lastNameValidate = isName(this.user.last_name);
        const cpfValidate = cpf.isValid(this.user.cpf);
        const telValidate = this.user.phones.number.length === 9;
        
        if (emailValidate && nameValidate && lastNameValidate && cpfValidate && telValidate) {
          if (this.user.verified_at === "1") {
            const currentDate = new Date().toLocaleDateString('pt-BR');
            this.user.verified_at = toTimeStamp(currentDate);
          } else {
            this.user.verified_at = null;
          }
          
          axios.post('store_user_por_corretor', this.user).then(res => {
            let token = res.data.token;
            let token_ajustado = this.parseJwt(token);
            let sub_id = token_ajustado.usr.sub_id;

            this.$swal.fire({
                position: "center",
                type: "success",
                title: "Cadastrado com sucesso!",
                showConfirmButton: true,
            });
            this.isLoading = false;
            const routeData = this.$router.resolve({name: 'DetalheOportunidade', params: {id: `${sub_id}`}});
            this.cpf = "";
            this.phones = "";
            this.zip_code = "";
            this.user = {
              phones: {
                number: "",
                area_code: "",
              },
              name: "",
              last_name: "",
              email: "",
              login: "",
              password: "",
              street: "",
              street_number: "",
              naturalidade: "",
              complement: "",
              district: "",
              zip_code: "",
              city: "",
              cpf: "",
              state: "",
              country: "",
              plans: [],
              verified_at: "1"
            }
            window.open(routeData.href, '_blank');
            //this.$router.replace(this.$route.query.redirect || `/corretor/oportunidades/detalhes/${sub_id}`);
          }).catch(e => {
            this.user.verified_at = this.user.verified_at ? '1' : '0';
            let responseError = e.response.data.message;
            if (responseError.includes("cpf")){
              this.$swal.fire({
                position: "center",
                type: "error",
                title: "CPF já cadastrado!",
                showConfirmButton: true,
              });
            } else{
              this.$swal.fire({
                position: "center",
                type: "error",
                title: "Erro ao realizar cadastro!",
                text: responseError,
                showConfirmButton: true,
              });
            }
            this.isLoading = false;
          })
        } else {
          let text = "";
          if (!emailValidate) text = 'Por favor, digite um email válido!'
          else if (!cpfValidate) text = 'Por favor, digite um CPF válido!'
          else if (!telValidate) text = 'Por favor, digite um telefone válido!'
          else if (!nameValidate || !lastNameValidate) text = 'Nome e Sobrenome não devem conter números ou caracteres especiais!'
          
          this.$swal.fire({
            position: "center",
            type: "warning",
            title: "Aviso",
            text,
            showConfirmButton: true,
          });
          this.isLoading = false;
        }
      }
    },
    changeIconPassword() {
      this.isLocked = !this.isLocked;
      this.inputPasswordType = this.isLocked ? "password" : "text";
      
    },
    addPlan(e){
      this.user.plans.push({id: e.target.value.split('-')[0], qtd: 1})
      e.target.value = ""
    },
    subPlan(plan){
      if(plan.qtd > 1){
        this.user.plans.find(item => item.id == plan.id).qtd--;
      }else{
        this.user.plans = this.user.plans.filter(item => item.id != plan.id)
      }
    },
    sumPlan(plan){
      this.user.plans.find(item => item.id == plan.id).qtd++;
    },
    getAddress(code) {
      if (code.length > 8) {
        this.isLoading = true;
        fetch(`https://viacep.com.br/ws/${code}/json/`)
          .then((res) => res.json())
          .then((res) => {
            this.user.zip_code = res.cep.replace(/[^0-9]/g, '');
            this.user.city = res.localidade;
            this.user.country = "BRA";
            this.user.district = res.bairro;
            this.user.state = res.uf;
            this.user.street = res.logradouro;
          })
          .catch( (e) => {
            this.zip_code = "";
            this.user.zip_code = "";
            this.user.city = "";
            this.user.district = "";
            this.user.state = "";
            this.user.street = "";
            this.user.street_number = "";
            this.user.complement = "";
            this.$swal.fire({
              position: "center",
              type: "error",
              title: "Erro",
              text: 'Por favor, insira um CEP válido.',
              showConfirmButton: true,
            });
          })
        this.isLoading = false;
      } else {
        if (code.length > 0) {
          this.$swal.fire({
            position: "center",
            type: "warning",
            title: "Aviso",
            text: "Digite um CEP válido.",
            showConfirmButton: true,
          });
        }
        this.zip_code = '';
        this.user.city = '';
        this.user.district = '';
        this.user.state = '';
        this.user.street = '';
        this.user.street_number = '';
        this.user.complement = '';
      }
    },
    preencheLogin(){
      let self = this;
      self.user.login = self.user.email;
    },
    isEmpty(fields) {
      const emptyFields = [];
      Object.entries(fields).forEach(element => {
          if (element[0] === 'phones') {
            Object.entries(fields.phones).forEach(el => {
              if(el[1] === ""){
                emptyFields.push(el[0])
              }
            })
          } else if (element[0] === 'verified_at') {
            if(element[1] === ""){
              emptyFields.push(element[0])
            }
          } else {
            if(element[1] === "" || element[1] === '0'){
              emptyFields.push(element[0])
            }
          }
      });
      let returnMessage = ""
      emptyFields.forEach(el => {
          el == 'password' ? el = 'Senha' : el;
          el == 'name' ? el = 'Nome' : el;
          el == 'last_name' ? el = 'Sobrenome' : el;
          el == 'street' ? el = 'Rua' : el;
          el == 'district' ? el = 'Bairro' : el;
          el == 'zip_code' ? el = 'CEP' : el;
          el == 'cpf' ? el = 'CPF' : el;
          el == 'login' ? el = 'Login' : el;
          el == 'email' ? el = 'Email' : el;
          el == 'street_number' ? el = 'Número' : el;
          el == 'number' ? el = 'Telefone' : el;
          //returnMessage += `* O campo <b>${el}</b> está vazio <br/>`
          if (el != 'city' && el != 'state' && el != 'country' && el != 'naturalidade' && el != 'complement' && el != 'area_code')
           returnMessage += '<b>* ' + el + '</b><br>'
      })
      return returnMessage;
    }
  }
};
</script>
<style scoped>
.list_plans{
  background-color: #f4f6fa;
  padding: 20px 10px;
  border-radius: 5px;
}

.counter{
  display: flex;
  justify-content: center;
  align-items: center;
}
.counter .op{
  width: 30px;
  height: 30px;
  border-radius: 5px;
  background-color: #af104c;
  font-size: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: white;
  font-weight: bold;
}

.counter .quant{
  font-size: 25px;
  margin: 0px 10px;
  font-weight: bold;
  color: black;
}

.container-nameCount{
  display: flex;
  flex-flow: column;
  align-items: center;
}

.list_plans .item{
  background-color: white;
  border-radius: 5px;
  padding: 15px 10px;
  cursor: pointer;
  box-shadow: 3px 3px 10px rgba(0, 0, 0, 0.056);
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.item img{
  max-width: 90px;
  border-radius: 10px;
  margin-right: 10px;
}

.name{
  background-color: #af104c;
  color: white;
  padding: 2px 5px;
  margin-bottom: 10px;
  border-radius: 60px;
  font-size: 10px;
  text-align: center;
}

.inputContainer{
  position: relative;
}

.inputIcon{
  position: absolute;
  right: 1.2rem;
  top: .54rem;
  font-size: 1.25rem;
  user-select: none;
  cursor: pointer;
  padding: .2rem .4rem;
}

.checkboxContainer{
  width: 11rem;
}

@media screen and (min-width: 500px) {
  .name{
    padding: 2px 15px;
    font-size: 13px;
    margin-bottom: 18px;
  }

  .item img{
    max-width: 110px;
  }
}
</style>